import { motion } from "framer-motion";
import { logEvent } from "firebase/analytics";
import { analytics } from "../firebase";
import DeleteMyDataForm from "../components/DeleteMyDataForm";
type Props = {};

const DeleteMyDataPage = (props: Props) => {
	var deviceId = localStorage.getItem("sftdvcid");

	return (
		<motion.section
			onViewportEnter={() => {
				logEvent(analytics, "section_visited", {
					deviceId,
					section: "contact",
				});

				document.title = "Contact with Softwarify | Premium Software Solutions & Services";
			}}
			initial={{
				opacity: 0,
				x: -50,
			}}
			whileInView={{
				opacity: 1,
				x: 0,
				transition: {
					duration: 0.5,
					delay: 0.2,
					ease: "easeInOut",
				},
			}}
			className='w-screen lg:h-screen py-20 space-y-10 overflow-hidden'
			id='contact'>
			<DeleteMyDataForm />
		</motion.section>
	);
};

export default DeleteMyDataPage;
